module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.ba78458a.svg";